var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.fecha))]),_c('div',{staticClass:"hora"},[_c('span',{staticClass:"hora__ticker"},[_vm._v(" "+_vm._s(_vm.hora)+" ")]),_vm._v(" "),_c('span',{staticClass:"hora__ticker-posfix"},[_vm._v("hrs.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }